






import { Component, Vue } from 'vue-property-decorator'
@Component
export default class Order extends Vue {

    toOrderList(){
        console.log('order');
    }
}
